import { Cancel, Delete, Edit, Save } from '@mui/icons-material';
import { ButtonProps, Divider, IconButton, Tooltip } from '@mui/material';
import { TooltipProps } from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { SolaForceHeading } from '~/components/SolaForceHeading';

export type ContactTabSectionHeadingProps = {
  heading?: string;
  canEdit: boolean;
  readMode: boolean;
  onDelete?: ButtonProps['onClick'];
  onSave: ButtonProps['onClick'];
  onCancel: ButtonProps['onClick'];
  onEdit: ButtonProps['onClick'];
};

export const ContactTabSectionHeading = (
  props: ContactTabSectionHeadingProps,
) => {
  const { heading, readMode, canEdit, onDelete, onSave, onCancel, onEdit } =
    props;

  const { t } = useTranslation();

  const tooltipProps: Partial<TooltipProps> = {
    placement: 'top',
    arrow: true,
  };

  return (
    <>
      <SolaForceHeading heading={heading}>
        {canEdit && (
          <>
            {readMode ? (
              <Tooltip title={t('laEdit')} {...tooltipProps}>
                <IconButton onClick={onEdit} size={'small'} color={'primary'}>
                  <Edit />
                </IconButton>
              </Tooltip>
            ) : (
              <>
                {!!onDelete && (
                  <>
                    <Tooltip title={t('laClear')} {...tooltipProps}>
                      <IconButton onClick={onDelete} size={'small'}>
                        <Delete />
                      </IconButton>
                    </Tooltip>
                    <Divider orientation={'vertical'} />
                  </>
                )}
                <Tooltip title={t('laSave')} {...tooltipProps}>
                  <IconButton onClick={onSave} size={'small'} color={'success'}>
                    <Save />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t('laCancel')} {...tooltipProps}>
                  <IconButton onClick={onCancel} size={'small'} color={'error'}>
                    <Cancel />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </>
        )}
      </SolaForceHeading>
    </>
  );
};
